<template>
    <DsConfirmDialog
        :is-open="isOpen"
        :title="$t('funnel.edit.lightbox.campaign.delete')"
        :message="$t('funnel.edit.delete.confirmation')"
        :confirm-label="$t('funnel.edit.lightbox.delete')"
        :cancel-label="$t('funnel.edit.cancel')"
        @cancel="closeDeleteCampaignModal"
        @confirm="deleteCampaign"
    />
</template>

<script>
import { deleteAutomation } from './delete.automation.api';

export default {
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        funnelId: {
            type: Number,
            required: true,
        },
    },
    emits: ['close-delete-campaign-modal'],
    methods: {
        async deleteCampaign() {
            try {
                const response = await deleteAutomation(this.funnelId);

                window.location.href = response;
            } catch (error) {
                this.$error({ message: this.$t('funnel.edit.lightbox.campaign.delete.failed') });
            }
        },
        closeDeleteCampaignModal() {
            this.$emit('close-delete-campaign-modal');
        },
    },
};
</script>
